/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { readOnly, notEmpty } from '@ember/object/computed';
import Component from '@ember/component';
import computedChange from 'cio/utils/computed-change';
import { defineProperty } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class Measure extends Component {
  // external API
  measure = null;

  metric = null;
  originalMetric = null;
  availableMeasures = null;
  showCanTrackOpens = false;

  // internal
  @notEmpty('originalMetric') isVariation;

  change = null;
  ratio = null;
  total = null;

  didReceiveAttrs() {
    super.didReceiveAttrs(...arguments);

    let key = this.get('measure.key');

    if (!isEmpty(key)) {
      defineProperty(this, 'change', computedChange(`${key}.rawRate`));
      defineProperty(this, 'ratio', readOnly(`metric.${key}.rawRate`));
      defineProperty(this, 'total', readOnly(`metric.${key}.rawTotal`));
    }
  }
}
